<template>
<keep-alive include="Products">
    <router-view/>
</keep-alive>
</template>

<script>
export default {
    name: "RouterView.vue"
}
</script>

<style scoped>

</style>